import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useEffect, useMemo, useState } from 'react';

import type { TPassportUnitCodeSuggestItem } from 'shared/types';

import type { TPassportFormFields } from 'entities/creditForm';
import { useGetUnitCodes } from 'entities/creditForm';

export const usePassportSuggestions = () => {
  const { watch } = useFormContext<TPassportFormFields>();
  const [loadUnitCodes, { isFetching: isLoading, data }] = useGetUnitCodes();
  const [debouncedQuery, setDebouncedQuery] = useState('');

  const unitCodeValue = watch('unitCode');

  // debounce вводимого значения кода подразделения
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedQuery(String(unitCodeValue).replace(/\D/g, ''));
    }, 1_000);

    return () => clearTimeout(timeout);
  }, [unitCodeValue]);

  // запрос кодов подразделений по введенному значению
  useEffect(() => {
    if (debouncedQuery && debouncedQuery.length > 2) {
      loadUnitCodes(debouncedQuery, true);
    }
  }, [debouncedQuery, loadUnitCodes]);

  return useMemo(() => {
    const onlyDigitsCode = String(debouncedQuery).replace(/\D/g, '');
    const isFullCode = onlyDigitsCode.length === 6;
    const isAvailableToSearch = onlyDigitsCode.length > 2;
    const issuedByOptions: Array<Dictionaries.TSelectOption<string, TPassportUnitCodeSuggestItem>> = isFullCode
      ? (data || [])
          .filter((item) => {
            return String(item.data?.code || '').replace(/\D/g, '') === onlyDigitsCode;
          })
          .map((item) => ({ label: item.data?.name || '', value: item.data?.name || '', data: item.data }))
      : [];

    return {
      issuedByOptions,
      isLoading,
      uniteCodeOptions: isAvailableToSearch ? data || [] : [],
    };
  }, [isLoading, data, debouncedQuery]);
};
